import { render } from "./secondSection.vue?vue&type=template&id=6ff12e8c"
import script from "./secondSection.vue?vue&type=script&lang=js"
export * from "./secondSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__